export default "__VITE_ASSET__rdyv4xvx__"